// extracted by mini-css-extract-plugin
module.exports = {"columnsWrapper":"columnsWrapper___1rMfH","titleAndText":"titleAndText___3gCSN","latestTitle":"latestTitle___3xQy3","hasTitle":"hasTitle___QL1cX","textLink":"textLink___2fwau"};